import styled from 'styled-components';

export const StyledByuPage = styled.div`
  max-width: 1280px;
  padding: 40px 90px 0 90px;
  background-color: #f7f7f7;
  display: flex;
  position: absolute;
  top: 80px;
  bottom: 80px;
`;
